// Section « Mes pièces » côté candidat : exigences selon la situation, dépôt et remplacement,
// constats visibles (les mêmes que ceux du bailleur), pièces interdites.
import { useGet } from "@core/hooks";
import { ErrorBox, Loading, Notice } from "@core/ui";
import { RequirementsView } from "./pieces";
import { blockTone, countsText, RunLine, SplitChecks, type Block } from "./shared";
import { Badge, Card } from "@core/ui";

export function MesPieces({ applicationId }: { applicationId: string }) {
  const q = useGet<{ blocks: Block[]; analyse: any }>(`/api/v1/applications/${applicationId}/constats`);
  return (
    <div className="stack">
      <Notice tone="info">
        Votre dossier est vérifié avec les pièces que vous fournissez. Vous voyez les mêmes constats que le bailleur et pouvez corriger une pièce. Seules les pièces autorisées par la loi vous sont demandées.
      </Notice>
      <RequirementsView applicationId={applicationId} canWrite />
      {q.isLoading ? <Loading /> : null}
      <ErrorBox error={q.error} />
      {q.data && q.data.analyse ? (
        <Card title="Constats sur votre dossier">
          <RunLine run={q.data.analyse} />
          <div className="controle-blocs">
            {q.data.blocks.map((b) => (
              <div key={b.block} className="controle-bloc">
                <p className="eyebrow">{b.title}</p>
                <p>
                  <Badge tone={blockTone(b.state)}>{b.state_label}</Badge>
                </p>
                <p className="controle-compte">{countsText(b.counts)}</p>
                <SplitChecks checks={b.checks} />
              </div>
            ))}
          </div>
          <p className="small muted">Un constat « à confirmer » appelle une précision ou une pièce, pas une conclusion. Vous pouvez corriger une valeur mal lue ou remplacer une pièce ; les contrôles concernés sont alors refaits.</p>
        </Card>
      ) : null}
    </div>
  );
}
